<template>
    <div class="noticias">
        <div id="noticias" class="ancla"></div>
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">stay up to date</p>
                        <p v-else-if="lang == 'esp'">mantente al día</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <h2 v-if="lang == 'eng'">Recent News</h2>
            <h2 v-else-if="lang == 'esp'">Noticias Recientes</h2>
            <b-row>
                <b-col cols="12" md="4">
                    <div class="noticia" v-b-modal.noticia1>
                        <img src="../assets/img/img_art1_sm.jpg" alt="Noticias">
                        <div v-if="lang == 'eng'">
                            <h5>Why choose Digital Out Of Home?</h5>
                            <p>Digital Outdoor Advertising or Digital Out of Home (DOOH) is one of the most trending means of advertising exposure...</p>
                        </div>
                        <div v-else-if="lang == 'esp'">
                            <h5>¿Por qué elegir Digital Out Of Home?</h5>
                            <p>La Publicidad Exterior Digital o por sus siglas en inglés se Digital Out of Home (DOOH) es uno de los medios de exposición publicitaria de mayor tendencia...</p>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4" class="noticiaCentro">
                    <div class="noticia" v-b-modal.noticia2>
                        <img src="../assets/img/img_art2_sm.jpg" alt="Noticias">
                        <div v-if="lang == 'eng'">
                            <h5>DOOH o Digital Outdoor Advertising as an extension of your Social Network or Website</h5>
                            <p>Digital outdoor advertising is the future in outdoor advertising, that is why we can take advantage of it as an extension of our website or social network, but...</p>
                        </div>
                        <div v-else-if="lang == 'esp'">
                            <h5>DOOH o Publicidad exterior digital como extensión de tu Red Social o Página Web</h5>
                            <p>La publicidad exterior digital es el futuro en publicidad exterior, es por eso por lo que podemos aprovecharlo como una extensión de nuestra página web o red social, pero...</p>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="4">
                    <div class="noticia" v-b-modal.noticia3>
                        <img src="../assets/img/img_art3_sm.jpg" alt="Noticias">
                        <div v-if="lang == 'eng'">
                            <h5>The human brain processes images in just 13 thousandths of a second</h5>
                            <p>In much less than a second our brain is capable of processing images. In fact, a recent study carried out by scientists...</p>
                        </div>
                        <div v-else-if="lang == 'esp'">
                            <h5>El cerebro humano procesa las imágenes en solo 13 milésimas de segundo</h5>
                            <p>En muchísimo menos de un segundo nuestro cerebro es capaz de procesar las imágenes. De hecho un estudio reciente llevado a cabo por científicos...</p>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <ModalNoticias/>
    </div>
</template>

<script>
    import ModalNoticias from './ModalNoticias'
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        components: {
            ModalNoticias
        }
    }
</script>

<style scoped>
    .noticias{
        padding: 140px 0;
        position: relative;
    }
    h2{
        text-align: center;
        margin-bottom: 30px;
    }
    img{
        width: 100%;
        margin-bottom: 15px;
    }
    h5{
        font-family: 'sailecBlack';
        margin: 0;
    }
    p{
        font-size: 10pt;
        margin-top: 10px;
    }
    small{
        opacity: 60%;
    }
    .noticia{
        outline: none!important;
    }

    @media screen and (max-width: 767px){
        .noticias{
            padding: 100px 0;
        }
        .noticiaCentro{
            margin: 40px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Noticias.vue